import translate from '@logistics-frontend/core/i18n/translate'

import {config} from '../shared/config'

export const i18n = translate(config.lang, config.i18n)
